module.exports = __webpack_public_path__ + "static/media/  (40).4b9ce84b.jpg";